module.exports = __webpack_public_path__ + "static/img/main1.47de9ade.gif";